import { State } from "country-state-city";

const usStates = State.getStatesOfCountry("US");

const codeByName = new Map(
  usStates.map((state) => [state.name.trim().toLowerCase(), state.isoCode])
);

const validCodes = new Set(usStates.map((state) => state.isoCode));

export const normalizeUSStateToAlpha2 = (value: string | undefined): string => {
  const input = (value ?? "").trim();
  if (!input) {
    return "";
  }

  const upperInput = input.toUpperCase();
  if (upperInput.length === 2 && validCodes.has(upperInput)) {
    return upperInput;
  }

  const code = codeByName.get(input.toLowerCase());
  if (code) {
    return code;
  }

  return upperInput.slice(0, 2);
};